import React, { useState } from 'react';
import { t } from 'bv-i18n';
import Modal from './modal';

export default () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const hide = () => { setVisible(false); };

  return (
    <Modal
      onCloseClick={hide}
      onOverlayClick={hide}
      danger
      overlayFullscreen
      iconClosable
    >
      {t('errors_something_wrong')}
    </Modal>
  );
};
